import React from 'react';
import styled from 'styled-components';

import fonts from 'app/src/styles/fonts';

// Renders a clean, semantic HTML string (h1-h4, p, ul/li, strong, a) styled to
// match the rest of the site. Used for static legal documents (Terms, Privacy)
// exported from termsfeed. The page is rendered inside the app shell
// (Header/Menu/Footer when logged in, Header/Footer via Auth when logged out),
// so it only supplies the document body.
const Container = styled.div`
  max-width: 800px;
  font-family: ${fonts.body};
  font-size: 16px;
  line-height: 1.5;
  color: #1a1a1a;

  h1 {
    font-size: 28px;
  }

  h2 {
    font-size: 22px;
    margin-top: 28px;
  }

  h3 {
    font-size: 18px;
    margin-top: 20px;
  }

  h4 {
    font-size: 16px;
    margin-top: 16px;
  }

  a {
    color: darkgreen;
  }

  ul {
    padding-left: 22px;
  }
`;

const HtmlDocument = ({ html }) => {
  return <Container dangerouslySetInnerHTML={{ __html: html }} />;
};

export default HtmlDocument;
